<!--

 Copyright © 2026 Ping Identity Corporation. All right reserved.

 This software may be modified and distributed under the terms
 of the MIT license. See the LICENSE file for details.

 -->

<script lang="ts">
  export let classes = '';
  export let size = '24px';
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width={size}
  height={size}
  viewBox="0 0 21 21"
  class={classes}
>
  <path fill="#f25022" d="M1 1h9v9H1z" />
  <path fill="#7fba00" d="M11 1h9v9H11z" />
  <path fill="#00a4ef" d="M1 11h9v9H1z" />
  <path fill="#ffb900" d="M11 11h9v9H11z" />
</svg>
